import { render, staticRenderFns } from "./ForumDeleteDialog.vue?vue&type=template&id=10818bfc&"
import script from "./ForumDeleteDialog.vue?vue&type=script&lang=js&"
export * from "./ForumDeleteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports